import React, { useContext, useState } from 'react'
import loginIcons from '../assest/signin.gif'
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import Context from '../context';
import { useEffect } from 'react';
import ROLE from '../common/role';
import { useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const Login = () => {
    const user = useSelector(state => state?.user?.user);
    const [loading, setLoading] = useState(false);
    const [showPassword,setShowPassword] = useState(false)
    const [data,setData] = useState({
        email : "",
        password : ""
    })
    const navigate = useNavigate()
    const { fetchUserDetails, fetchUserAddToCart } = useContext(Context)

    const handleOnChange = (e) =>{
        const { name , value } = e.target

        setData((preve)=>{
            return{
                ...preve,
                [name] : value
            }
        })
    }


    const handleSubmit = async(e) =>{
        e.preventDefault()

        const dataResponse = await fetch(SummaryApi.signIn.url,{
            method : SummaryApi.signIn.method,
            credentials : 'include',
            headers : {
                "content-type" : "application/json"
            },
            body : JSON.stringify(data)
        })

        const dataApi = await dataResponse.json()

        if(dataApi.success){
            toast.success('تم تسجيل الدخول بنجاح')
            navigate('/')
            fetchUserDetails()
            fetchUserAddToCart()
        }

        if(dataApi.error){
            toast.error(dataApi.message)
        }

    }

    useEffect(() => {
        setLoading(true);
        if (user) {
            if(user?.role === ROLE.GENERAL){
                navigate("/");
                setLoading(false);
            }

           else if (user?.role === ROLE.ADMIN) {
                if (user?.type === "Medicine") {
                    navigate("/admin-home");
                    setLoading(false);
                } 
                else if(user?.type === "Cosmetic") {
                    navigate("/admin-cosmetic-home");
                    setLoading(false);
                }
                else if (user?.type ==="Admin"){
                    navigate("/admin-panel/all-users");
                    setLoading(false);
                }
                
            } 

            else if (user?.role === ROLE.SALESMAN) {
        
              navigate("/salesManPanel/salesManViewOrders");
              setLoading(false);
    
          }
            
            else {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }, [user, navigate]);


    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
            </div>
        );
    }
    
  return (
    <section id='login'>
        <div className='mx-auto container p-4'>

            <div className='bg-white p-5 w-full max-w-sm mx-auto'>
                    <div className='w-20 h-20 mx-auto'>
                        <img src={loginIcons} alt='login icons'/>
                    </div>

                    <form className='pt-6 flex flex-col gap-2 text-right rtl' onSubmit={handleSubmit}>
                        <div className='grid'>
                            <label>: البريد الالكتروني  </label>
                            <div className='bg-slate-100 p-2'>
                                <input 
                                    type='email' 
                                    placeholder='ادخل بريد الكتروني' 
                                    name='email'
                                    value={data.email}
                                    onChange={handleOnChange}
                                    className='w-full h-full outline-none bg-transparent'/>
                            </div>
                        </div>

                        <div>
                            <label>: كلمة المرور </label>
                            <div className='bg-slate-100 p-2 flex'>
                                <input 
                                    type={showPassword ? "text" : "password"} 
                                    placeholder='ادخل كلمة المرور'
                                    value={data.password}
                                    name='password' 
                                    onChange={handleOnChange}
                                    className='w-full h-full outline-none bg-transparent'/>
                                <div className='cursor-pointer text-xl' onClick={()=>setShowPassword((preve)=>!preve)}>
                                    <span>
                                        {
                                            showPassword ? (
                                               
                                                <FaEye/>

                                            )
                                            :
                                            (
                                                <FaEyeSlash/>
                                            )
                                        }
                                    </span>
                                </div>
                            </div>
                            <Link to={'/forgot-password'} className='block w-fit ml-auto hover:underline hover:text-red-600'>
                                هل نسيت كلمة المرور؟
                            </Link>
                        </div>

                        <button className='bg-blue-900  hover:bg-blue-800  text-white px-6 py-2 w-full max-w-[150px] rounded hover:scale-110 transition-all mx-auto block mt-6'>تسجيل الدخول</button>

                    </form>

                    <p className='my-5 text-right rtl'>ليس لديك حساب ؟ <Link to={"/sign-up"} className=' text-blue-900 hover:text-blue-800 hover:underline'>انشاء حساب </Link></p>
            </div>


        </div>
    </section>
  )
}

export default Login